import { Component, h } from 'preact';
import CSSModules from 'react-css-modules';
import ClassNames from 'classnames';
import styles from '../../css/app.css';
import TweenLite from 'gsap/TweenLite';
import TimelineLite from 'gsap/TimelineLite';
import ReactMarkdown from 'react-markdown';
import _throttle from 'lodash/throttle';

class Hologram extends Component {
  constructor(props) {
    super(props);
    this._onOrientation = this.onOrientation.bind(this);
    this._throttledOrientation = _throttle(this._onOrientation, 15);
    this.HOLO_ANGLE_START = 5;
    this.HOLO_ANGLE_RANGE = 20;
    this.HOLO_PERCENT_FACTOR = 100 / (this.HOLO_ANGLE_RANGE - this.HOLO_ANGLE_START);
    this.initialised = false;
    this.destroyTimer = null;
    this.startAngle = null;
    this.tl = new TimelineLite({ paused: true });
  }

  componentDidUpdate(prevProps,prevState) {
    if (prevProps.order !== this.props.order) this.initOrDestroy();
  }

  componentDidMount() {
    this.tl.to(this.radialRef, 1, { 
      width: '260vmax', 
      height: '260vmax',
    })
    .to(this.floTextRef, 1, { 
      opacity: 0.1
    }, 0)
    .to(this.ghostTextRef, 1, {
      opacity: 1,
      '-webkit-filter': 'blur(0px)'
    });
    this.initOrDestroy(this.props);
  }

  componentWillUnmount() {
    this.destroyGhost();
  }

  onOrientation(e) {
    if (!this.startAngle) {
      this.startAngle = e.gamma;
    } else {
      let gamma = e.gamma;  
      gamma = this.startAngle - gamma;
      if (Math.abs(gamma) <= this.HOLO_ANGLE_START) {
        this.fxPercent = 0;
      } else if (Math.abs(gamma) <= this.HOLO_ANGLE_RANGE) {
        let ratio = gamma < 0 ? 
          gamma + this.HOLO_ANGLE_START
          : 
          gamma - this.HOLO_ANGLE_START;
        this.fxPercent = this.HOLO_PERCENT_FACTOR * ratio;
      } else {
        this.fxPercent = 100 * (gamma < 0 ? -1 : 1);
      }

      this.tl.progress(Math.abs(this.fxPercent * 0.01));
    }
  }

  initOrDestroy() {
    if (this.props.order === 'curr'
      && this.initialised === false) {

      this.initialised = true;
      this.startTimer = setTimeout(() => this.initGhost(), 5);
    } else {
      this.destroyGhost();
    }
  }

  initGhost() {
    console.log('!!init HOLO panel!!', this.props.pageNumber);
    this.startAngle = null;
    TweenLite.to(this.radialRef, 1, {
      opacity: 1,
    });
    window.addEventListener('deviceorientation', this._throttledOrientation);
  }

  destroyGhost() {
    clearTimeout(this.startTimer);
    if (!this.initialised) return;

    console.log('@@destroy HOLO panel@@', this.props.pageNumber);
    this.initialised = false;
    this.tl && this.tl.progress(0);
    clearTimeout(this.startTimer);
    TweenLite.set(this.radialRef, { opacity: 0 });
    window.removeEventListener('deviceorientation', this._throttledOrientation);
  }

  storeRef(type, el) {
    if (el !== null) this[type] = el;
  }

  render() {
    return (
      <div styleName='fake-hologram' 
        className={ClassNames(this.props.order)}>

        <div className='inner'
          ref={r => this.storeRef('floTextRef', r)}> 
          
          {this.props.paragraphs.map((text,i) => {
            return <ReactMarkdown source={text} />
          })}
        </div>

        <div className='ghost-effect'>
          <i class="radial" ref={r => this.storeRef('radialRef', r)} />
          <div className='inner'
            ref={r => this.storeRef('ghostTextRef', r)}>

            {this.props.ghost.paragraphs.map((text,i) => {
              return <ReactMarkdown source={text} />
            })}
          </div>
        </div>
      </div>
    )
  }
}

// Apply 'react-css-modules' to this react component:
export default CSSModules(Hologram, styles);
// export default Hologram;



// WEBPACK FOOTER //
// ./app/frontend/components/panels/ghost-hologram.jsx